import apiFetch from '../apiFetch'

export default function (token) {    
  return apiFetch({endPoint: `Pool/saveDataSplitsPIC`, method: 'POST', token: token})
}
